import { Box, Group, Stack, Text } from "@mantine/core";
import { FiAlertCircle } from "react-icons/fi";

import classes from "./_css/SuspendedAccountCard.module.css";

export function SuspendedAccountCard() {
  return (
    <Box className={classes.card}>
      <Stack gap={4}>
        <Group gap="xs" wrap="nowrap">
          <FiAlertCircle
            className={classes.icon}
            size={18}
            aria-hidden="true"
          />
          <Text className={classes.title}>
            アカウントが利用停止になっています
          </Text>
        </Group>
        <Text className={classes.description}>
          現在、求人の応募や各種手続きはご利用いただけません。詳細はお問い合わせください。
        </Text>
      </Stack>
    </Box>
  );
}
